const en = {
  contact: {
    heroHeading: 'Get In Touch',
    heroSub: "Whether you're buying, selling, or investing \u2014 our team is here to help you every step of the way.",
    expertsBadge: 'Meet Our Experts',
    expertsHeading: 'The People Behind Victory Homes',
    officeLabel: 'Office Location',
    phoneLabel: 'Phone Numbers',
    phoneOffice: 'Office',
    phoneWA: 'Call / WhatsApp',
    emailLabel: 'Email Us',
    followLabel: 'Follow Us',
    formHeading: 'Send Us a Message',
    formSub: 'Fill out the form below and our team will get back to you within 24 hours.',
    fieldName: 'Your Name *',
    fieldEmail: 'Email Address *',
    fieldPhone: 'Phone Number',
    fieldSubject: 'Subject',
    fieldMessage: 'Your Message *',
    sendBtn: 'Send Message',
    sentBtn: '\u2713 Message Sent!',
    thankYou: "Thank you! We'll respond within 24 hours.",
  },
  mort: {
    heroBadge: 'Mortgage Services',
    heroLine1: 'UAE Mortgage Solutions',
    heroAccent: 'Tailored for You',
    heroSub: 'Calculate your EMI, check your eligibility, and explore mortgage products from 15+ UAE banks \u2014 all in one place.',
    tabCalc: '\ud83d\udcca Mortgage Calculator',
    tabElig: '\u2705 Eligibility Check',
    // Calculator
    loanParams: 'Loan Parameters',
    propertyValue: 'Property Value',
    downPayment: 'Down Payment',
    annualRate: 'Annual Interest Rate',
    loanTenure: 'Loan Tenure',
    years: (n) => `${n} Years`,
    minDown: '20% (min)',
    maxUAE: '25 Yrs (max UAE)',
    monthlyEMI: 'Monthly EMI',
    loanAmount: 'Loan Amount',
    totalInterest: 'Total Interest',
    totalPayable: 'Total Payable',
    principalVsInterest: 'Principal vs Interest',
    principal: 'Principal',
    interest: 'Interest',
    compareRates: '\ud83c\udfe6 Compare UAE Bank Rates',
    amortSchedule: '\ud83d\udcc5 Annual Amortization Schedule',
    basedOnLoan: (amt, yrs) => `Based on your loan of AED ${amt} over ${yrs} years. Rates are illustrative \u2014 contact us for live bank quotes.`,
    bankCol: 'Bank',
    fixedRate3yr: 'Fixed Rate (3yr)',
    variableEIBOR: 'Variable (EIBOR+)',
    monthlyEMIFixed: 'Monthly EMI (Fixed)',
    totalCost: 'Total Cost',
    eibor3mNote: (rate) => `* EIBOR 3M: ${rate}% (reference rate). Variable rates reset periodically. Actual rates subject to bank assessment.`,
    yearCol: 'Year',
    principalPaid: 'Principal Paid',
    interestPaid: 'Interest Paid',
    balanceRemaining: 'Balance Remaining',
    yearRow: (n) => `Year ${n}`,
    // Eligibility
    financialProfile: 'Your Financial Profile',
    residencyStatus: 'Residency Status',
    residencyOpts: [
      { value: 'resident',    label: '\ud83c\udfe0 UAE Resident',   desc: '80% LTV \u00b7 25yr max' },
      { value: 'national',    label: '\ud83c\udde6\ud83c\uddea UAE National',   desc: '85% LTV \u00b7 25yr max' },
      { value: 'nonresident', label: '\u2708\ufe0f Non-Resident',    desc: '50% LTV \u00b7 15yr max' },
    ],
    yourAge: 'Your Age',
    ageUnit: 'yrs',
    monthlySalary: 'Monthly Salary (AED)',
    otherIncome: 'Other Monthly Income',
    existingEMI: 'Existing Loan EMIs (AED/mo)',
    creditCard: 'Credit Card Limit (AED)',
    ccNote: 'Banks count 5% of limit as monthly burden',
    assumedRate: 'Assumed Interest Rate',
    checkBtn: '\ud83d\udd0d Check My Eligibility',
    fillDetails: 'Fill in your details',
    fillDesc: "Based on UAE Central Bank DBR rules, we'll calculate the maximum mortgage you qualify for across UAE banks.",
    errTitle: 'Eligibility could not be calculated',
    errDesc: 'Your existing liabilities may exceed the 50% DBR limit, or your age leaves insufficient tenure. Please contact our advisors.',
    maxLoan: 'Maximum Loan Amount',
    maxProperty: 'Max Property Value',
    minDownPay: 'Min Down Payment',
    maxTenure: 'Max Loan Tenure',
    maxEMI: 'Max Allowable EMI',
    dbrTitle: 'UAE Central Bank DBR Analysis',
    grossIncome: 'Gross Monthly Income',
    existingObligs: 'Existing Obligations',
    dbrHeadroom: 'DBR Headroom (50% rule)',
    ltvApplied: 'LTV Applied',
    dbrNote: 'Results are indicative based on UAE CB Mortgage Regulations. Actual eligibility subject to individual bank assessment, credit score, and employment type.',
    readyApply: 'Ready to apply?',
    readyApplyDesc: 'Our mortgage advisors will secure you the best rate across 15+ UAE banks.',
    talkAdvisor: 'Talk to an Advisor \u2192',
    // Services
    servicesBadge: 'Our Services',
    servicesHeading: 'Everything You Need Under One Roof',
    servicesSub: 'Victory Homes works with leading UAE banks to deliver mortgage services that are transparent, fast, and stress-free.',
    services: [
      { icon: '\ud83c\udfe0', title: 'Residential Mortgages', desc: 'Finance your dream home in the UAE with competitive rates from top banks tailored to your profile.' },
      { icon: '\u2708\ufe0f', title: 'Non-Resident Mortgages', desc: 'Live outside the UAE but want to invest here? We arrange mortgages for overseas buyers with up to 50% LTV.' },
      { icon: '\ud83d\udd04', title: 'Buyout & Equity Release', desc: 'Paying too much on your existing mortgage? Switch banks and potentially save thousands in interest.' },
      { icon: '\ud83c\udfd7\ufe0f', title: 'Land & Construction', desc: 'Finance land purchases and construction projects with specialist products designed for off-plan builds.' },
      { icon: '\ud83d\udccb', title: 'Free Eligibility Assessment', desc: 'We assess your profile and provide a pre-qualification letter showing eligibility across 5+ UAE banks.' },
      { icon: '\ud83d\udc64', title: 'Personal Mortgage Advisor', desc: 'Every client gets a dedicated advisor who guides them from application to final approval and handover.' },
    ],
    ctaHeading: 'Ready to take the next step?',
    ctaSub: 'Our mortgage advisors are on hand to help you secure the best deal. Free consultation, no obligation.',
    ctaBtn: 'Book Free Consultation \u2192',
  },
  offplan: {
    heroBadge: '\u2726 Dubai Off-Plan Properties',
    heroLine1: 'Invest Before the',
    heroAccent: 'City Does.',
    heroSub: "Exclusive pre-launch access to Dubai's most sought-after developments. Secure prime units at today's prices \u2014 before the market moves.",
    browseBtn: 'Browse Projects',
    advisorBtn: 'Speak to an Advisor',
    statGrowth: 'Avg. Capital Growth',
    statVisa: 'Golden Visa Threshold',
    statComm: 'Commission to Buyer',
    whyBadge: 'Why Off-Plan',
    whyHeading: "The Smart Investor's Choice",
    why: [
      { icon: '\ud83d\udcb0', title: 'Lower Entry Price', desc: 'Buy at pre-launch rates \u2014 typically 20\u201330% below market value at completion.' },
      { icon: '\ud83d\udcc5', title: 'Flexible Payment Plans', desc: 'Developers offer 40/60 or 20/80 payment plans \u2014 spread your investment over the construction period.' },
      { icon: '\ud83d\udcc8', title: 'Capital Appreciation', desc: 'Dubai off-plan historically delivers 30\u201350% growth from launch to handover in prime communities.' },
      { icon: '\ud83e\ude99', title: 'Golden Visa Eligible', desc: 'Properties AED 2M+ qualify for the 10-year UAE Golden Visa on handover. Our team guides the process.' },
    ],
    featuredBadge: 'Featured Developments',
    featuredHeading: 'Handpicked Off-Plan Projects',
    catalogueLink: 'Request Full Catalogue \u2192',
    showingOf: (shown, total) => `Showing ${shown} of ${total} projects`,
    noMatchTitle: 'No matching properties found',
    noMatchDesc: "We couldn't find any off-plan projects matching your current criteria. Please consider broadening your search, reducing the applied filters, or selecting a different location.",
    clearFilters: 'Clear All Filters',
    communitiesBadge: 'Explore Communities',
    communitiesHeading: "Dubai's Most Desirable Areas",
    seeListings: 'See all listings \u2192',
    locations: [
      {
        name: 'Downtown',
        desc: [
          "Rising at the heart of Dubai's most iconic district, Downtown embodies the essence of refined urban living. Sculpted towers frame the skyline with confidence, their contemporary forms reflecting the city's ambition and global stature.",
          "Within, residents are immersed in an elevated lifestyle experience. Expansive lounges, panoramic terraces and thoughtfully designed social spaces offer uninterrupted views of the city's most celebrated landmarks.",
        ],
      },
      {
        name: 'Palm Jumeirah',
        desc: [
          "Rooted in heritage yet shaped by modern elegance, Palm Jumeirah represents one of Dubai's most distinguished residential destinations. Its refined streetscapes, contemporary architecture, and timeless appeal create an environment where sophistication feels effortless.",
          "Living here is defined by balance and prestige. Thoughtfully designed residences, serene outdoor spaces, and curated interiors come together to form a lifestyle of comfort and privacy.",
        ],
      },
      {
        name: 'Marina',
        desc: [
          "Rising along Dubai's shimmering coastline, Dubai Marina captures the energy of city living with the serenity of waterfront elegance. Its sleek towers and illuminated promenades create a vibrant skyline.",
          "Life in Dubai Marina is defined by movement and leisure. Residents enjoy private marinas, scenic boardwalks, and panoramic terraces with uninterrupted water views.",
        ],
      },
      {
        name: 'Dubai Hills',
        desc: [
          "Nestled within the heart of Dubai, Dubai Hills redefines modern living with a seamless blend of nature and urban sophistication. Its tree-lined avenues and rolling fairways create a tranquil environment.",
          "Life in Dubai Hills is defined by wellness, elegance, and community. Expansive homes, panoramic terraces, and landscaped green spaces offer residents the perfect balance of leisure and refinement.",
        ],
      },
      {
        name: 'Arabian Ranches',
        desc: [
          "Set amidst sprawling landscapes and tranquil greenery, Arabian Ranches offers a unique blend of contemporary living and suburban serenity. Its elegant villas, tree-lined streets, and open spaces create a community where comfort and privacy are paramount.",
          "Life in Arabian Ranches is defined by family, leisure, and refinement. Residents enjoy landscaped gardens, community parks, golf courses, and thoughtfully designed interiors that balance modern aesthetics with warm, inviting touches.",
        ],
      },
    ],
  },
  sell: {
    heroBadge: 'List Your Property',
    heroHeadline: 'Partner with',
    heroAccent: 'Victory Homes',
    heroSub: 'List your property with our expert team for sale or rent. We handle everything from valuation to closing.',
    formBadge: 'For Property Owners',
    formHeading: 'List Your Property With Us',
    formSub: 'Fill in the form and our dedicated team will handle everything — from valuation to closing.',
    tabSell: '🏷️ Sell',
    tabRent: '🔑 Rent',
    sectionContact: 'Contact Details',
    sectionProperty: 'Property Details',
    sectionDocs: 'Legal Documents',
    sectionPhotos: 'Property Photos',
    fullName: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    whatsapp: 'WhatsApp (optional)',
    propertyType: 'Property Type',
    selectType: '— Select type —',
    emirate: 'Emirate',
    selectEmirate: '— Select emirate —',
    community: 'Community / Area',
    subCommunity: 'Sub-community / Building',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    select: '— Select —',
    areaSqFt: 'Area (sq ft)',
    floor: 'Floor / Level',
    furnishing: 'Furnishing',
    completion: 'Completion',
    ready: 'Ready',
    offPlan: 'Off-Plan',
    askingPrice: 'Asking Price',
    rentAmount: 'Rent Amount (per year)',
    priceHint: 'Enter the amount without commas. Price should reflect current market value.',
    youtubeLink: 'YouTube Video Link',
    youtubeHint: 'Add a YouTube link to showcase your property (optional)',
    description: 'Property Description',
    descPlaceholder: 'Describe your property — features, views, upgrades, nearby amenities…',
    docsIntro: 'These documents verify ownership and facilitate a smooth listing. All files are handled securely.',
    titleDeed: 'Title Deed',
    titleDeedHint: 'Official title deed from DLD or local authority.',
    floorPlan: 'Floor Plan',
    floorPlanHint: 'Architectural floor plan. PDF or image preferred.',
    passport: 'Passport Copy',
    passportHint: 'Valid passport of the property owner.',
    privacy: 'Privacy Guaranteed. Your documents are encrypted and only accessible to our authorised team.',
    photosLabel: 'Property Photos',
    photosHint: 'Up to 20 images — JPG, PNG, WEBP. First image will be the cover.',
    photosIntro: 'Great photos dramatically increase enquiries. Use bright, wide-angle shots of every room.',
    dragDrop: 'Drag & drop or',
    browse: 'browse',
    accepted: 'PDF, JPG, PNG accepted',
    clickReplace: 'Click to replace',
    dropPhotos: 'Drop photos here',
    orClickBrowse: 'or click to browse',
    upTo20: 'Up to 20 images',
    photosAdded: (n) => `${n} photo${n > 1 ? 's' : ''} added`,
    submitSale: '🚀 Submit Sale Listing',
    submitRental: '🚀 Submit Rental Listing',
    submitting: '⏳ Submitting…',
    termsNotice: 'By submitting, you agree to Victory Homes\u2019 Terms of Service.',
    successTitle: 'Listing Submitted!',
    successDesc: 'Our team will review and get in touch within',
    successHours: '24 hours',
    submitAnother: 'Submit Another',
    errName: 'Full name is required',
    errEmail: 'Valid email is required',
    errPhone: 'Phone number is required',
    errPropType: 'Select property type',
    errEmirate: 'Select emirate',
    errPrice: 'Asking price is required',
    errRent: 'Rent amount is required',
    errPhotos: 'At least one property photo is required',
  },
  props: {
    heroBadge: 'UAE Properties',
    listingCount: (n) => `${n} ${n === 1 ? 'listing' : 'listings'} available`,
    tabBuy: 'Buy',
    tabRent: 'Rent',
    portfolio: 'Our Portfolio',
    forSale: 'Properties For Sale',
    forRent: 'Properties For Rent',
    listYourProperty: 'List Your Property →',
    buy: {
      badge: 'Properties For Sale',
      headline: 'Find Your Perfect',
      accent: 'Property to Buy',
      sub: 'Explore verified sale listings handpicked by our expert team across the UAE.',
    },
    rent: {
      badge: 'Properties For Rent',
      headline: 'Discover Your Ideal',
      accent: 'Rental Property',
      sub: 'Browse quality rental listings across Dubai and the Emirates, curated by Victory Homes.',
    },
    enquireNow: 'Enquire Now →',
    noMatchTitle: 'No listings match your filters',
    noMatchDesc: 'Try adjusting your budget, type, or area to see more results.',
    clearFilters: 'Clear All Filters',
    emptyBuy: 'No Properties Currently Listed for Sale',
    emptyRent: 'No Properties Currently Listed for Rent',
    emptyDesc: (mode) => `We don't have any ${mode === 'rent' ? 'rental' : 'for-sale'} properties actively listed at this time. Our portfolio is regularly updated — please check back soon or reach out directly.`,
    speakAgent: 'Speak to an Agent →',
    listProp: 'List Your Property',
    exploreOther: 'Explore Other Properties',
    otherForSale: 'Other Properties Available For Sale',
    otherForRent: 'Other Properties Available For Rent',
    otherDesc: 'While we source this category, here are other properties from our portfolio you may find of interest.',
    ctaBadge: 'Ready to List?',
    ctaHeading: 'Have a Property to List?',
    ctaDesc: 'Our expert brokers handle everything from valuation to closing — or finding you the perfect tenant. List your property with Victory Homes today.',
    contactUs: 'Contact Us',
  },
  featured: {
    tag: 'Exclusive Properties',
    heading: 'Explore Exclusive Properties with Emirates',
    desc: 'Discover the finest selection of luxurious homes and prime real estate opportunities with Emirates. Step into the lifestyle you deserve.',
  },
  partners: {
    tag: 'Our Partners',
    heading: 'Properties from leading developers in UAE',
    learnMore: 'Learn More',
    learnMoreArrow: 'Learn More →',
    oasis: { title: 'Oasis Garden Villas', desc: 'Spacious contemporary homes with private gardens, shaded courtyards, and nature-inspired layouts crafted for peace, elegance, and family-focused living.' },
    ghaf:  { title: 'Ghaf Woods by Dubai', desc: 'A low-density residential enclave with eco-conscious homes, pedestrian-friendly spaces, and abundant green cover — designed for wellness and long-term living.' },
    nad:   { title: 'Nad Al Sheba', desc: 'An exclusive residential district with spacious villas in a peaceful, low-density environment, renowned for privacy, greenery, and proximity to key Dubai landmarks.' },
    district: { title: 'District One, Dubai', desc: 'Ultra-luxury master-planned community with elegant villas and mansions set around crystal lagoons and lush green spaces — designed for privacy and prestige.' },
  },
  media: {
    tag: 'Media Coverage',
    heading: 'Featured In the News',
    readArticle: 'Read Article',
  },
  newsletter: {
    badge: 'Stay Informed',
    heading: 'Stay Ahead of Dubai\'s Property Market',
    desc: 'Get exclusive listings, market insights, and investment opportunities delivered to your inbox — before they hit the market.',
    placeholder: 'Enter your email address',
    btn: 'Subscribe →',
    privacy: '🔒 No spam. Unsubscribe anytime. Your data is safe with us.',
    success: '✓ You\'re subscribed! Welcome to the Victory Homes community.',
    error: 'Please enter a valid email address.',
  },
  nav: {
    home: 'Home', properties: 'Properties', buy: '🏡 Buy', rent: '🔑 Rent',
    sellRent: 'Sell/Rent', offplan: 'Offplan', services: 'Services',
    holidayHomes: 'Holiday Homes', propertyManagement: 'Property Management',
    fitOut: 'Fit out Renovation works, Home Shifting & Packers',
    legalAssistance: 'Legal Assistance',
    valuation: 'Property Valuation',
    calculators: 'Mortgage',
    transactions: 'Transactions',
    mortgage: 'Mortgage Calculator', contact: 'Contact Us', roiCalc: 'ROI Calculator',
    areaIntelligence: 'Area Intelligence',
  },
  valuation: {
    heroTitle: 'Free Market Property Valuation',
    heroDesc: 'Thinking of selling? Get an instant, data-driven assessment of your property\'s current market value from our experts.',
    successTitle: 'Request Received!',
    successDesc: 'Our valuation experts will review your property details and contact you shortly.',
    submitAnother: 'Submit Another Request',
    fullName: 'Full Name *',
    phone: 'Phone Number *',
    email: 'Email Address',
    propType: 'Property Type *',
    selectType: 'Select Type',
    location: 'Location / Community *',
    locPlaceholder: 'e.g. Dubai Marina',
    bedrooms: 'Bedrooms',
    select: 'Select',
    area: 'Built-up Area (Sq.Ft)',
    areaPlaceholder: 'e.g. 1500',
    submit: 'Get My Free Valuation',
    submitting: 'Submitting...',
    fail: 'Failed to submit request. Please try again.'
  },
  recentlySold: {
    title: 'Recently Sold Properties',
    desc: 'A selection of our latest successful transactions. Experience the Victory Homes difference.',
    badge: 'Sold',
    beds: 'Beds'
  },
  trust: {
    clientStories: 'Client Stories',
    hearFromClients: 'Hear from our clients',
    videoUnavailable: 'Video Unavailable',
    trackRecord: 'Track Record',
    provenSuccess: 'Proven Success'
  },
  areaIntelligence: {
    heroBadge: 'Dubai Area Intelligence',
    heroLine1: 'Data-Driven Insights for',
    heroAccent: 'Every Dubai District.',
    heroSub: 'Explore price trends, rental yields, and AI-powered investment insights across Dubai\'s most sought-after communities — all in one intelligent map.',
    modeBuy: 'Buy',
    modeRent: 'Rent',
    modeOffplan: 'Off-Plan',
    filterTitle: 'Filters & Metrics',
    heatmapLabel: 'Map Metric',
    chartAreasLabel: 'Chart Areas',
    selectAll: 'All',
    selectNone: 'None',
    loading: 'Loading area data…',
    mapsKeyMissing: 'Google Maps API Key Required',
    mapsKeyHint: 'Add VITE_GOOGLE_MAPS_API_KEY to your .env file and GOOGLE_MAPS_API_KEY to backend/.env, then reload.',
    mapFailedLoad: 'Map failed to load. Check your API key.',
    mapLoading: 'Loading map…',
    // Color legend
    legendSelectedArea: '⬤ Selected area',
    legendSelectedDesc: 'White bubble = your active selection',
    legendLow: { avgPrice: 'Lower Price', rentalYield: 'Lower Yield', demandScore: 'Low Demand', avgPricePerSqft: 'Lower $/sqft' },
    legendHigh: { avgPrice: 'Higher Price', rentalYield: 'Higher Yield', demandScore: 'High Demand', avgPricePerSqft: 'Higher $/sqft' },
    // Area panel
    activeProjects: 'Active Projects',
    nearbyLandmarks: '📍 Nearby Landmarks',
    kpiAvgPrice: 'Avg Price',
    kpiPricePerSqft: 'Price / sqft',
    kpiGrossYield: 'Gross Yield',
    kpiDemandScore: 'Demand Score',
    aiInsightTitle: '✦ AI Market Insight',
    aiGenerate: 'Generate →',
    aiAnalysing: 'Analysing market data…',
    aiKeyMissing: 'Add GEMINI_API_KEY to backend/.env to enable AI insights.',
    aiPrompt: 'Click "Generate" for a Gemini AI-powered investment analysis tailored to this area.',
    browseOffplan: (name) => `Browse Off-Plan in ${name} →`,
    viewResale: 'View Resale Properties →',
    // Charts
    priceTrendBadge: 'Price Trend',
    priceTrendTitle: '12-Month Price per sqft (AED)',
    priceTrendSub: 'Trailing 12-month trend based on market data aggregation',
    rentalYieldBadge: 'Rental Yield',
    rentalYieldTitle: 'Gross Rental Yield by Area (%)',
    rentalYieldSub: 'Based on average annual rent vs. average purchase price',
    tooltipYield: (val, name) => [`${val}% gross yield`, name],
    // Comparison table
    comparisonBadge: 'Area Comparison',
    comparisonTitle: 'Compare Up to 3 Areas',
    comparisonSub: 'Select areas below to compare side-by-side',
    comparisonPlaceholder: 'Select areas above to see a side-by-side comparison',
    colMetric: 'Metric',
    rowAvgPrice: 'Avg Price',
    rowPricePerSqft: 'Price / sqft',
    rowGrossYield: 'Gross Yield',
    rowDemandScore: 'Demand Score',
    rowActiveProjects: 'Active Projects',
    rowMinEntry: 'Min Entry Price',
    rowMaxPrice: 'Max Price',
    best: 'Best',
    // Metric config labels
    metricAvgPrice: 'Avg Price',
    metricRentalYield: 'Rental Yield',
    metricDemand: 'Demand',
    metricPricePerSqft: 'Price/sqft',
  },
  hero: {
    slide1H: 'Where smart data, curated guidance, and human trust come together.',
    slide1P: "Victory Homes is the UAE's first brokerage that helps people discover the life they want before they discover the home they need.",
    slide1Btn: 'ETA',
    slide2H: 'Exclusive Waterfront Estates.',
    slide2P: "Experience unparalleled luxury on the world's most iconic man-made island in Palm Jumeirah.",
    slide2Btn: 'Explore Palm',
    slide3H: 'Future Living, Perfectly Matched.',
    slide3P: 'Using environmental data and predictive modeling, we match people to visionary communities in Dubai Marina.',
    slide3Btn: 'Discover Marina',
    slide4H: 'Find the life, not just the home.',
    slide4P: 'Discover a private sanctuary surrounded by the legendary Crystal Lagoon and acres of lush greenery in District One.',
    slide4Btn: 'View District One',
  },
  stats: {
    impact: 'Our Business Impact',
    sold: 'Total Sold 2020–2024',
    lifetime: 'Lifetime Sales Volume',
    current: 'Current Listing Volume',
  },
  sellTestimonials: {
    tag: 'Testimonials',
    heading: 'Sell With Victory Homes Fast And Efficient',
    desc: "Experience a smooth, transparent process designed to maximize your property's value while minimizing your stress. Sell smart, sell fast.",
  },
  team: {
    tag: 'The Team',
    heading: "Connect with Emirates' Top Real Estate Experts",
    desc: 'Meet our dedicated agents at Victory Homes—experienced professionals ready to guide you through every step.',
    btn: 'Meet the Full Team →',
  },
  goldenVisa: {
    badge: '🇦🇪 Investor Benefit',
    heading: 'UAE Golden Visa',
    headingGold: 'Through Property',
    desc: 'Invest in UAE real estate worth <strong>AED 2,000,000 or more</strong> and unlock a <strong>10-year renewable UAE residency visa</strong> — for you and your family.',
    cta: 'Check My Eligibility →',
    benefitsHeading: 'Why the Golden Visa Is a Game-Changer',
    benefitsSubheading: "Beyond property ownership, the UAE Golden Visa opens doors that most countries simply don't offer.",
    stepsHeading: 'How To Get Your Golden Visa',
    stepsSubheading: '4 straightforward steps — our team guides you through every one',
    stepCtaHeading: 'Ready to secure your UAE Golden Visa?',
    stepCtaDesc: 'Our advisors will identify the right qualifying property for your budget and goals.',
    stepCtaBtn: 'Talk to an Advisor',
    yearVisa: 'Year Visa',
    minValue: 'Min. Property Value',
    benefits: {
      b1t: '10-Year Residency', b1d: 'Secure a decade-long UAE Golden Visa by investing in property worth AED 2 million or more.',
      b2t: 'Family Sponsorship', b2d: 'Sponsor your spouse, children, and parents under the same visa — no separate applications needed.',
      b3t: 'No Sponsor Required', b3d: 'Live, work, and study in the UAE without needing an employer or local sponsor.',
      b4t: 'Renewable Indefinitely', b4d: 'As long as you hold the qualifying property, the Golden Visa renews automatically with no restrictions.',
      b5t: 'Global Mobility', b5d: 'Enjoy multiple-entry privileges and stay outside the UAE for extended periods without losing visa validity.',
      b6t: 'Investment Security', b6d: 'UAE property is a Tier-1 asset class — combine elite residency with strong capital appreciation potential.',
    },
    steps: {
      s1: 'Purchase a property valued at AED 2M or more',
      s2: 'Obtain a Title Deed from the Dubai Land Department',
      s3: "Apply through ICA or GDRFA with our team's guidance",
      s4: 'Receive your 10-year Golden Visa & Emirates ID',
    },
  },
  blog: {
    tag: 'The Blog',
    heading: 'Insights and News from Emirates Real Estate Blog',
    desc: 'Get the latest market news, tips, and expert insights on Dubai real estate from Emirates Real Estate expert.',
    readMore: 'Continue reading',
  },
  evo: {
    statsBadge: 'Dubai By The Numbers',
    statsHeading: "Dubai's Real Estate Evolution",
    statsDesc: 'From a regional trading port to the world\'s most dynamic property market in just two decades.',
    timelineBadge: 'The Story',
    timelineHeading: "How Dubai Became the World's #1 Real Estate Destination",
    timelineCTA: "Want to understand where Dubai's market is heading next?",
    timelineBtn: 'Speak to a Market Expert →',
    stats: {
      s1l: 'Properties Transacted in 2024',
      s2l: 'AED Total Sales Value in 2024',
      s3l: 'Property Price Growth Since 2020',
      s4l: 'Nationalities Living in Dubai',
    },
    timeline: {
      t1t: 'Freehold Law Passes', t1d: 'Dubai allows foreigners to own property in designated freehold zones — triggering the first investment wave.',
      t2t: 'Skyline Transformation', t2d: "Burj Khalifa opens. Dubai becomes the world's most recognised modern city, cementing its global property appeal.",
      t3t: 'Golden Visa Introduced', t3d: 'UAE launches the 10-year Golden Visa programme, supercharging demand for AED 2M+ residential investments.',
      t4t: 'Record-Breaking Market', t4d: "Post-pandemic recovery drives an unprecedented 60%+ surge in prices — the world's best-performing real estate market.",
      t5t: 'New All-Time Highs', t5d: 'Dubai records 96,000+ transactions worth AED 411 Billion — eclipsing every previous annual record.',
      t6t: 'Dubai 2040 Urban Plan', t6d: 'Municipal masterplan targets doubling green spaces, 5 urban centres, and a population of 5.8 million by 2040.',
    },
  },
  txn: {
    badge: 'Powered by DXBinteract',
    heading: 'Dubai Transaction Reports',
    desc: 'Access live Dubai Land Department transaction data — every sale recorded, every price tracked, every trend mapped.',
    live: 'Live DLD Data',
    openPlatform: 'Open Full Platform ↗',
    viewReport: 'View Report →',
    ctaHeading: 'Want a personalised transaction report for a specific area?',
    ctaDesc: 'Our advisors can pull area-specific data and interpret it for your investment.',
    ctaBtn: 'Ask an Advisor',
    reports: {
      r1l: 'Daily Report', r1d: 'Every transaction recorded by DLD — updated daily.',
      r2l: 'Weekly Report', r2d: 'Weekly summary of sales volumes, prices, and area trends.',
      r3l: 'Monthly Report', r3d: 'Deep dive into monthly performance across all property types.',
      r4l: 'Quarterly Report', r4d: 'Quarter-on-quarter analysis: price shifts, top areas, investor activity.',
      r5l: 'Yearly Report', r5d: 'Full-year market overview: record deals, emerging communities, forecast.',
      r6l: 'Area Price Map', r6d: 'Interactive heatmap showing price per sqft across all Dubai communities.',
    },
  },
  cta: {
    buying: 'Start Buying', selling: 'Start Selling', contact: 'Contact Us',
    findOut: 'Find Out More', comingSoon: 'Coming Soon',
  },
  offplanPromo: {
    badge: 'Off-Plan Properties',
    heading: 'New Projects & Exclusive Pre-Launch Deals',
    desc: "Secure units in Dubai's most sought-after off-plan developments — before they sell out. Golden Visa eligible from AED 2M.",
    btn: 'Explore Off-Plan →',
  },
  topCommunities: {
    badge: 'Market Insights',
    heading: 'Dubai\'s Top Communities',
    desc: 'Strategic insights for investors and end-users (2026-2027)',
    tabs: {
      roi: 'ROI Leaders',
      villas: 'Villas & Townhouses',
      budget: 'By Budget',
      strategy: 'Strategy Guide'
    },
    roi: {
      title: 'Top Communities for ROI (2026–2027)',
      desc: 'These areas consistently deliver strong rental yields + capital appreciation.',
      list: [
        'Jumeirah Village Circle',
        'Dubai South',
        'Arjan',
        'Dubai Silicon Oasis',
        'Dubai Sports City',
        'Business Bay',
        'Dubai Marina'
      ],
      insightTitle: 'Key Insight',
      insights: [
        'JVC + Arjan = highest yields (6–9%)',
        'Marina + Business Bay = lower yield but stronger appreciation + liquidity'
      ]
    },
    villas: {
      title: 'Best Communities for Villas / Townhouses',
      desc: 'Focused on end-users, families, and long-term living.',
      list: [
        'Dubai Hills Estate',
        'Arabian Ranches',
        'Tilal Al Ghaf',
        'DAMAC Hills',
        'The Valley',
        'Mudon',
        'Town Square'
      ],
      insightTitle: 'Key Insight',
      insights: [
        'Dubai Hills = best balance (location + quality)',
        'Tilal Al Ghaf = premium lifestyle community',
        'Town Square / Valley = entry-level villas'
      ]
    },
    budget: {
      title: 'Best Communities by Budget',
      categories: [
        {
          name: 'Entry-Level',
          range: 'AED 500K – 900K',
          areas: ['International City', 'Dubai South', 'Discovery Gardens', 'Dubai Production City', 'Liwan'],
          bestFor: 'first-time investors, highest rental yield'
        },
        {
          name: 'Mid-Market',
          range: 'AED 900K – 2M',
          areas: ['Jumeirah Village Circle', 'Arjan', 'Al Furjan', 'Dubai Silicon Oasis', 'Dubai Creek Harbour'],
          bestFor: 'balance of ROI + appreciation'
        },
        {
          name: 'Upper Mid / Premium',
          range: 'AED 2M – 5M',
          areas: ['Business Bay', 'Dubai Marina', 'Dubai Hills Estate', 'Palm Jumeirah (entry-level units)'],
          bestFor: 'liquidity + strong resale demand'
        },
        {
          name: 'Luxury',
          range: 'AED 5M+',
          areas: ['Downtown Dubai', 'Palm Jumeirah', 'Emirates Hills', 'District One', 'Jumeirah Bay Island'],
          bestFor: 'capital preservation + prestige assets'
        }
      ]
    },
    strategy: {
      title: 'Simple Strategy Guide',
      guide: [
        { goal: 'maximum ROI', action: 'JVC, Arjan, Dubai South' },
        { goal: 'safe investment', action: 'Dubai Hills, Marina' },
        { goal: 'luxury appreciation', action: 'Palm Jumeirah, Downtown' },
        { goal: 'family living', action: 'Arabian Ranches, Tilal Al Ghaf' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "Victory Services",
    "whyChoose": "Why Choose Our {service}?",
    "form": {
        "fullName": "Full Name",
        "email": "Email Address",
        "phone": "Phone Number",
        "detailsOpt": "Property/Unit Details (Optional)",
        "messageOpt": "Additional Message or Requirements",
        "submitRequest": "Submit Request",
        "submitting": "Submitting...",
        "successTitle": "Request Received!",
        "successDesc": "Thank you for reaching out regarding our {service}. Our team will review your request and contact you shortly.",
        "submitAnother": "Submit Another Request",
        "errors": {
            "nameReq": "Please enter your full name",
            "emailReq": "Please enter a valid email address",
            "phoneReq": "Please enter your phone number",
            "failSub": "Failed to submit the request. Please try again later."
        },
        "placeholders": {
            "name": "e.g. John Doe",
            "email": "you@example.com",
            "phone": "+971 50 123 4567",
            "details": "e.g. 2 Bed Apartment in Downtown Dubai",
            "message": "How can we help you?"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "Holiday Homes",
            "heroSub": "Maximize your property yields with our premium short-term rental management.",
            "desc": "Turn your property into a lucrative holiday home with zero hassle. We handle marketing, guest management, and maintenance to ensure top-tier returns. Dubai's fast-paced tourism market offers excellent ROI for short-term rentals.",
            "extraDesc": "From furnishing and strategic styling to professional photography and optimized listings across global platforms, our specialized strategy ensures maximum occupancy. We also provide full 24/7 guest support, meaning absolute peace of mind for you.",
            "points": [
                "Dynamic Pricing & Marketing",
                "24/7 Guest Support & Concierge",
                "Professional Housekeeping",
                "Monthly ROI Reporting",
                "Legal & Registration Assistance"
            ],
            "formTitle": "Request Holiday Home Services",
            "formDesc": "Let us know how we can assist with your short-term rental goals."
        },
        "property-management": {
            "title": "Property Management",
            "heroSub": "Comprehensive management services for peace of mind and steady income.",
            "desc": "From tenant screening to maintenance requests, our dedicated team manages your real estate investments professionally and securely. Protect your assets while securing consistent rental yields.",
            "extraDesc": "We remove the day-to-day stress of being a landlord. Our service covers everything including Ejari registration, rent collection, regular property inspections, and handling emergency repairs with our trusted network of contractors.",
            "points": [
                "Comprehensive Tenant Screening",
                "Rent Collection & Financial Reporting",
                "Ejari & Legal Compliance",
                "Routine Inspections & Maintenance",
                "Dispute Resolution Services"
            ],
            "formTitle": "Request Property Management",
            "formDesc": "Provide your details and we will get back to you with a tailored management plan."
        },
        "fit-out": {
            "title": "Fit-Out Services",
            "heroSub": "Transform your space with our world-class interior design and fit-out solutions.",
            "desc": "Bespoke design, planning, and execution for residential and commercial spaces, ensuring high quality and timely delivery. Whether it is a luxury villa upgrade or a modern office layout.",
            "extraDesc": "Our experienced designers and project managers work closely with you from concept to completion. We also offer comprehensive home shifting, packers, and movers services for a seamless transition.",
            "points": [
                "Bespoke Interior Design Concepts",
                "Space Planning & 3D Visualization",
                "Turnkey Execution & Project Management",
                "Home Shifting & Relocation",
                "Professional Packers & Movers"
            ],
            "formTitle": "Request Fit-Out Consultation",
            "formDesc": "Schedule a consultation to discuss your vision for your property."
        },
        "legal-assistance": {
            "title": "Legal Assistance",
            "heroSub": "Expert legal guidance for secure and compliant real estate transactions in the UAE.",
            "desc": "Navigating Dubai's real estate laws requires precision. We provide complete legal support to ensure your property transactions are secure, compliant, and stress-free.",
            "extraDesc": "From thorough Title Verification to ensuring full RERA compliance and due diligence, our experts protect your interests. We guide you through the Sale Deed Checklist and Property Purchase processes.",
            "points": [
                "Title Verification & Due Diligence",
                "RERA Compliance & Guidance",
                "Sale Deed Checklist Preparation",
                "Property Purchase Verification",
                "Dispute Resolution & Advisory"
            ],
            "formTitle": "Request Legal Assistance",
            "formDesc": "Provide your details and our legal experts will get in touch with you."
        }
    }
},
  footer: {
    letsWork: "Let's work together",
    email: 'Email',
    callWhatsApp: 'Call / WhatsApp',
    ourLocation: 'Our location',
    officePhone: 'Office Phone',
    tagline: 'Your trusted real estate partner in Dubai. We specialize in buying, selling, and renting premium properties across the UAE with expert guidance every step of the way.',
    ourServices: 'Our Services',
    usefulLinks: 'Useful Links',
    copyright: '© 2025 Victory Homes. All rights reserved.',
    serviceLinks: ['New Properties', 'Sell Your Property', 'Our Services', 'Press Release'],
    headline: 'Our team of qualified real estate agents is ready & always available, anytime, anywhere.',
  },
  offplanDetail: {
    overview: "Overview",
    propertyTypes: "Property Types",
    totalUnits: "Total Units",
    handover: "Handover",
    startingPrice: "Starting Price",
    startingFrom: "Starting From",
    paymentPlan: "Payment Plan",
    location: "Location & Connectivity",
    mins: "Mins",
    unitType: "Unit Type",
    size: "Size",
    availableOptions: "Available Options",
    getBrochure: "Get Brochure",
    reqDetails: "Request Details",
    dlBrochure: "Download Brochure",
    dlFloorPlans: "Download Floor Plans",
    fullName: "Full Name *",
    emailAdd: "Email Address *",
    phoneNum: "Phone Number",
    reqDesc: "Fill in your details to receive the full project {type} for {name}.",
    reqSuccess: "Request Received",
    reqSuccessDesc: "Thank you. One of our specialists will email you the brochure and floor plans shortly.",
    close: "Close",
    submitting: "Submitting...",
    reqType: "Request {type}",
    types: {
        Apartment: "Apartment",
        Townhouse: "Townhouse",
        Villa: "Villa",
        Penthouse: "Penthouse",
        Mansion: "Mansion",
        Duplex: "Duplex",
        Plot: "Plot"
    },
    tags: {
        waterfront: "Waterfront",
        family: "Family",
        luxury: "Luxury",
        investment: "Investment",
        golf: "Golf Course",
        urban: "Urban",
        nature: "Nature"
    },
    beds: {
        studio: "Studio",
        br: "BR",
        units: "Units",
        various: "Various"
    }
}
,
  offplanExtra: {
        "interested": "Interested?",
        "readyToSecure": "Ready to Secure Your Unit in",
        "advisorGuide": "Our specialist advisors can guide you through pricing, payment options, and the full buying process — at zero commission.",
        "getInTouch": "Get in Touch",
        "whatsapp": "WhatsApp",
        "enquire": "Enquire",
        developer: "Developer",
    community: "Community",
    buildingHeight: "Building Height",
    retailSpace: "Retail Space",
    furnishing: "Furnishing",
    about: "About",
    investmentOutlook: "Investment Outlook",
    lifestyle: "Lifestyle",
    worldClassAmenities: "World-Class Amenities",
    unitTypes: "Unit Types",
    floorPlans: "Floor Plans",
    financing: "Financing",
    typesSuffix: "Types",
    sizeRange: "Size Range",
    units: "Units",
    from: "From",
        ofTotalPayment: "of total payment",
        whyOffPlan: "Why Off-Plan?",
        lowerEntryPrice: "Lower entry price vs ready properties",
        spreadPayments: "Spread payments over construction",
        capitalAppreciation: "Capital appreciation before handover",
        zeroCommission: "0% commission — buy direct",
        speakToAdvisor: "Speak to an Advisor",
        openMap: "Open Exact Location in Google Maps",
        nearbyPlaces: "Nearby Places",
        to: "to",
        booking: "Booking",
        installment: "Installment",
        handover: "Handover",
        areaUnit: "Area Unit",
        currency: "Currency",
        youtubeLink: "YouTube Video Link",
        watchVideo: "Watch Video",
        watchTour: "Watch Property Tour",
    },
  amenities: {
        "Kids Pool": "Kids Pool",
        "Private Beach Access": "Private Beach Access",
        "Marina Access": "Marina Access",
        "Outdoor Gym": "Outdoor Gym",
        "Basketball Court": "Basketball Court",
        "Tennis Court": "Tennis Court",
        "Padel Court": "Padel Court",
        "Cycling Track": "Cycling Track",
        "Spa & Wellness Center": "Spa & Wellness Center",
        "Kids Play Area": "Kids Play Area",
        "Clubhouse": "Clubhouse",
        "Library": "Library",
        "Retail Outlets": "Retail Outlets",
        "Cafes & Restaurants": "Cafes & Restaurants",
        "Supermarket": "Supermarket",
        "Concierge Service": "Concierge Service",
        "24/7 Security": "24/7 Security",
        "CCTV Surveillance": "CCTV Surveillance",
        "Mosque": "Mosque",
        "Pet Friendly": "Pet Friendly",
        "Dining Destinations": "Dining Destinations",
        "Yoga Studio": "Yoga Studio",
        "Lush Green Parks": "Lush Green Parks",
        "Valet Parking": "Valet Parking",
        "Smart Home Features": "Smart Home Features",
        "Sauna & Steam Room": "Sauna & Steam Room",
        "Covered Parking": "Covered Parking",
        "Landscaped Gardens": "Landscaped Gardens",
    "Swimming Pool": "Swimming Pool",
    "State-of-the-art Gym": "State-of-the-art Gym",
    "BBQ Area": "BBQ Area",
    "Sports Courts": "Sports Courts",
    "Infinity Pool": "Infinity Pool",
    "Running Track": "Running Track",
    "Cinema Room": "Cinema Room",
    "Games Room": "Games Room"
}
}

export default en
